<template>
  <div class="page-con">
    <div class="page-con-header clearfix" style="display: flex;align-items: center;">
      <Button type="primary" icon="ios-add" v-if="isHavePermission('traOnlinePay:create')" @click="openAdd">线上支付中转
      </Button>
      <vxe-button icon="vxe-icon--refresh" @click="refresh" style="margin-left: 20px">刷新</vxe-button>
      <div
          style="display: flex;align-items: center;margin-left: 30px;border: 1px solid #dcdfe6;height: 34px;border-radius: 4px;padding: 0 1em;">
        <span>付款扣除服务费：</span>
        <RadioGroup v-model="radioValue" @on-change="changeRadio" style="margin-left: 10px;">
          <Radio label="开启"></Radio>
          <Radio label="关闭"></Radio>
        </RadioGroup>
      </div>
    </div>
    <div class="list-box common-shadow clearfix">
      <vxe-table
          class="table-style"
          highlight-hover-row
          show-footer
          stripe
          align="center"
          border="none"
          auto-resize
          :data="tableData"
          max-height="540"
          :loading="loading"
          :filter-config="{remote: true}"
          @filter-change="filterTypeMethod"
      >
        <vxe-table-column field="id" title="序号" width="100">
          <template slot-scope="{ row }">
            <span>{{ row.id }}</span>
          </template>
        </vxe-table-column>
        <vxe-table-column title="操作">
          <template slot-scope="{ row }">
            <Dropdown trigger="click"
                      v-if="isHavePermission('traOnlinePay:update') || isHavePermission('traOnlinePay:delete')"
                      style="cursor:pointer" transfer>
              <icon type="text" custom="iconfont icon-gengduo" size="12px"></icon>
              <DropdownMenu slot="list" style="left:70px;">
                <div style="display: flex;flex-direction: column;">
                  <Button class="button-gengduo" v-if="isHavePermission('traOnlinePay:update')"
                          @click="openUpdateView(row)">
                    编辑
                  </Button>
                  <Button class="button-gengduo" v-if="isHavePermission('traOnlinePay:delete')"
                          @click="commitDelete(row.id)"
                          style="color: #ed4014;">删除
                  </Button>
                </div>
              </DropdownMenu>
            </Dropdown>
          </template>
        </vxe-table-column>
        <vxe-table-column field="middleManName" title="中转对象"></vxe-table-column>
        <vxe-table-column field="rate" title="费率">
          <template slot-scope="{ row }">
            <span>{{row.rate.toFixed(2)}}%</span>
          </template>
        </vxe-table-column>
        <vxe-table-column field="isActive" title="状态"
                          :filters="[{label: '启用', value: 1}, {label: '禁用', value: 0}]"
                          :filter-multiple="false">
          <template slot-scope="{ row }">
            <span v-if="row.isActive === 1" style="color: #67c23a;cursor: pointer;"
                  @click="changeActive(row,0)">启用</span>
            <span v-else style="color: red;cursor: pointer;" @click="changeActive(row,1)">禁用</span>
          </template>
        </vxe-table-column>
      </vxe-table>
      <!-- <vxe-pager
          background
          size="small"
          :current-page.sync="page.currentPage"
          :page-size.sync="page.pageSize"
          :total="page.totalResult"
          @page-change="changePage"
      ></vxe-pager>-->
    </div>
    <vxe-modal v-model="showAdd" title="线上支付中转" @close="closeAddModal" width="650" height="400" resize remember>
      <create-tra-online-pay @afterSave="refresh" @close="closeAdd" ref="onlinePay"></create-tra-online-pay>
    </vxe-modal>
  </div>
</template>

<script>
  import $api from "@/apiProvider";
  import getAuthOrization from "@/mixin/getAuthOrization";
  import CreateTraOnlinePay from "@/views/user/CreateTraOnlinePay.vue";
  import {hideLoading, showLoading} from '@/utils/util';

  export default {
    name: "TraOnlinePay",
    components: {CreateTraOnlinePay},
    props: {
      userId: Number,
      userName: String
    },
    mixins: [getAuthOrization],
    data() {
      return {
        title: "",
        showAdd: false,
        accountData: {},
        commitType: 1,
        visible: false,
        updateVisible: false,
        loading: false,
        tableData: [],
        page: {
          currentPage: 1,
          pageSize: 100,
          totalResult: 100,
        },
        radioValue: '关闭'
      };
    },
    mounted() {
      this.list();
      this.getIsPayMinusRate();
    },
    methods: {
      async getIsPayMinusRate() {
        let res = await $api.baseUserSign.post(`getIsPayMinusRate`, {
          id: this.userId
        });
        if (res.status === 1) {
          if (res.data === 1) {
            this.radioValue = '开启';
          } else {
            this.radioValue = '关闭';
          }
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      changeRadio(e) {
        if (e === '开启') {
          this.setIsPayMinusRate(1);
        } else {
          this.setIsPayMinusRate(0);
        }
      },
      async setIsPayMinusRate(state) {
        let res = await $api.baseUserSign.post(`setIsPayMinusRate`, {
          id: this.userId,
          state: state
        });
        if (res.status === 1) {
          this.$Message.success('设置成功');
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      filterTypeMethod({column, property, values, datas, filters, $event}) {
        this.page.currentPage = 1;
        if (values.length > 0) {
          this.isActive = values[0];
        } else {
          this.isActive = null;
        }
        this.list();
      },
      changeActive(row, active) {
        this.$XModal.confirm('您确定要' + (active === 1 ? '启用' : '禁用') + '吗？').then(type => {
          if (type === 'confirm') {
            this.setActive(row, active);
          }
        })
      },
      async setActive(row, active) {
        showLoading();
        let res = await $api.middleMan.post("setActive", {
          id: row.id,
          isActive: active
        });
        hideLoading();
        if (res.status === 1) {
          let message = active === 1 ? '启用成功！' : '禁用成功！';
          this.$XModal.message({message: message});
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      openUpdateView(row) {
        this.showAdd = true;
        this.$refs.onlinePay.setUpdate(row);
      },
      commitDelete(id) {
        this.$XModal.confirm('您确定要删除吗？').then(type => {
          if (type === 'confirm') {
            this.remove(id);
          }
        })
      },
      async remove(id) {
        let res = await $api.middleMan.post("remove", {id: id});
        hideLoading();
        if (res.status === 1) {
          this.$XModal.message({message: '删除成功！'});
          this.list();
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      openAdd() {
        this.showAdd = true;
        this.$refs.onlinePay.init({
          id: this.userId,
          name: this.userName
        })
      },
      async list() {
        this.loading = true;
        let res = await $api.middleMan.post("list", {
          pageNum: this.page.currentPage,
          pageSize: this.page.pageSize,
          id: this.userId,
          status: this.isActive,
        });
        this.loading = false;
        if (res.status === 1) {
          this.tableData = res.data.rows;
        } else {
          this.$XModal.alert({
            message: res.message ? res.message : "接口异常",
            status: "error",
          });
        }
      },
      refresh() {
        this.list();
      },
      closeAddModal() {
        this.$refs.onlinePay.cancelEvent();
      },
      closeAdd() {
        this.showAdd = false;
      },
    }
  };
</script>

<style>
  @import "../../../src/assets/icon/icon-filter/iconfont.css";
  @import "../../../src/assets/icon/icon-more/iconfont.css";

  .button-gengduo {
    border: none;
  }

  .button-gengduo:focus {
    outline: none;
    border-color: transparent;
    box-shadow: none;
  }

  .page-con-header {
    margin-bottom: 10px;
    position: relative;
  }
</style>